import { Dimensions, StyleSheet } from 'react-native'
import theme from '../../../theme'
import { LoginTheme, TriviaTheme } from '../../../themeConstants'
import Constants from 'expo-constants'
const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: theme.colors.colorPrimary,
        paddingTop: Constants.statusBarHeight + 10,
    },
    infoHeader: {
        flexDirection: 'row',
        width: width,
        height: 52,
        backgroundColor: 'transparent',
        //backgroundColor: 'rgba(255, 255, 255, 0.5)',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 12,
        marginTop: 40,
    },
    arrow: { marginHorizontal: 12, marginVertical: 10 },
    containerCups: {
        flex: 1,
    },
    podium: {
        width: width * 1.2,
        height: width * 1.2,
    },
    firstPositionCup: {
        width: 100,
        height: 100,
        borderRadius: 50,
    },
    firstPosition: {
        width: 25,
        height: 60,
        backgroundColor: theme.colors.colorPrimary,
        alignSelf: 'center',
    },
    secondPositionCup: {
        width: 76,
        height: 76,
        borderRadius: 38,
    },
    secondPosition: {
        width: 25,
        height: 40,
        backgroundColor: theme.colors.colorPrimary,
        alignSelf: 'center',
    },
    thirdPositionCup: {
        width: 64,
        height: 64,
        borderRadius: 32,
    },
    thirdPosition: {
        width: 25,
        height: 20,
        backgroundColor: theme.colors.colorPrimary,
        alignSelf: 'center',
    },
    userImage: {
        width: 54,
        height: 54,
        borderWidth: 3.0,
        borderRadius: 27,
        borderColor: 'white',
    },
    userImageCrown: {
        width: 80,
        height: 80,
        borderWidth: 4.0,
        borderRadius: 40,
        borderColor: 'white',
    },
    containerRanking: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'white',
    },
    ranking: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
    },
    borderButton: {
        borderWidth: 1.0,
        borderColor: LoginTheme.backButtonTextColor,
        backgroundColor: 'white',
        paddingVertical: 8,
        paddingHorizontal: 12,
        borderRadius: 10,
    },
    borderButtonText: {
        color: LoginTheme.backButtonTextColor,
        fontWeight: 'bold',
        fontSize: 14,
        textAlign: 'center',
    },
    containerItem: {
        flexDirection: 'row',
        padding: 15,
    },
    position: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.colorSecondary,
    },
    containerRankingPoints: {
        borderColor: theme.colors.colorTertiary,
        borderWidth: 1.0,
        borderRadius: 12,
        paddingVertical: 6,
        paddingHorizontal: 8,
    },
    points: {
        fontSize: 14,
        fontWeight: 'bold',
        color: theme.colors.colorPrimary,
        alignContent: 'center',
        //height: 30,
    },
    hr: {
        fontSize: 15,
        color: theme.colors.colorPrimary,
        alignContent: 'center',
        height: 18,
    },
    username: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
        alignContent: 'center',
    },
    usernamePodium: {
        fontSize: 13,
        fontWeight: '600',
        color: 'white',
    },
    containerPoints: {
        borderColor: theme.colors.colorTertiary,
        backgroundColor: 'white',
        borderWidth: 1.0,
        paddingVertical: 6,
        paddingHorizontal: 12,
        borderRadius: 12,
    },
    alignCenter: {
        alignSelf: 'center',
    },
    alignItemsCenter: {
        alignItems: 'center',
    },
    marginTop: {
        marginTop: 6,
    },
    divider: {
        flex: 1,
        borderWidth: 0.5,
        borderColor: theme.colors.lightGray,
    },
    divider2: {
        flex: 1,
        borderWidth: 0.5,
        borderColor: theme.colors.lightGray,
    },
    divider3: {
        flex: 1,
        borderWidth: 0.5,
        borderColor: theme.colors.lightGray,
        marginTop: 5,
        marginBottom: 10,
    },
    triviaItem: {
        flex: 1,
        paddingHorizontal: 15,
        flexDirection: 'row',
        alignContent: 'center',
        alignItems: 'center',
        textAlign: 'left',
    },
    benefitsModule: {
        flex: 1,
        padding: 10,
        flexDirection: 'row',
    },
    triviaImage: {
        width: 40,
        marginRight: 12,
        aspectRatio: 1,
        alignItems: 'center',
        borderRadius: 20,
    },
    triviaName: {
        fontSize: 15,
        marginBottom: 2,
        fontWeight: 'bold',
        color: theme.colors.colorPrimary,
        textTransform: 'capitalize',
    },
    triviaDescription: {
        fontSize: 14,
        marginBottom: 2,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textTransform: 'capitalize',
    },
    justifyCenter: {
        justifyContent: 'center',
    },
    status: {
        fontSize: 12,
        fontWeight: 'bold',
        textTransform: 'uppercase',
        textAlign: 'center',
        paddingHorizontal: 10,
        paddingVertical: 3,
        borderRadius: 5,
        overflow: 'hidden',
        alignItems: 'center',
    },
    points: {
        fontSize: 14,
        fontWeight: '600',
        color: theme.colors.textSecondary,
        textTransform: 'capitalize',
        textAlign: 'left',
    },
    dividerHorizontalLine: {
        flex: 1,
        borderBottomWidth: 0.5,
        borderBottomColor: theme.colors.lightGray,
        //marginVertical: 10,
        paddingBottom: 10,
        marginHorizontal: 12,
    },
    podium_user_points_text: {
        fontWeight: 'bold',
        fontSize: 15,
        color: TriviaTheme.podiumUserPointsTextcolor,
    },
    podium_user_points_Pts: {
        fontSize: 15,
        color: TriviaTheme.podiumUserPointsTextcolor,
    },
})

export default styles
